import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=5ff722ed&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Users/ben/Documents/GitHub/casa-padrino-theme/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ben/Documents/GitHub/casa-padrino-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff722ed')) {
      api.createRecord('5ff722ed', component.options)
    } else {
      api.reload('5ff722ed', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=5ff722ed&", function () {
      api.rerender('5ff722ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/casa/CategoryItem.vue"
export default component.exports